export class FieldOverride {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fieldPath",
            "baseName": "fieldPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetType",
            "baseName": "targetType",
            "type": "FieldOverrideTargetType",
            "format": ""
        },
        {
            "name": "parseFormat",
            "baseName": "parseFormat",
            "type": "string",
            "format": ""
        },
        {
            "name": "onParseError",
            "baseName": "onParseError",
            "type": "FieldOverrideOnError",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FieldOverride.attributeTypeMap;
    }
    constructor() {
    }
}
